export default __webpack_public_path__ + "static/media/confirmation.f2035288.png";